// Generated by purs version 0.15.15
import * as Ouroboros_Models_Core_Ok from "../Ouroboros.Models.Core.Ok/index.js";
import * as Ouroboros_Services_FFI_Task from "../Ouroboros.Services.FFI.Task/index.js";
var sequence = Ouroboros_Services_FFI_Task.sequence;
var run = Ouroboros_Services_FFI_Task.run;
var pure = Ouroboros_Services_FFI_Task.pure;
var map = Ouroboros_Services_FFI_Task.map;
var sequenceOk = function (tasks) {
    return map(function (v) {
        return Ouroboros_Models_Core_Ok.ok;
    })(sequence(tasks));
};
var fromIO = Ouroboros_Services_FFI_Task.fromIO;
var chain = function (f) {
    return function (task) {
        return Ouroboros_Services_FFI_Task.chain(task)(f);
    };
};
var tap = function (f) {
    return function (task) {
        return chain(function (value) {
            return map(function (v) {
                return value;
            })(f(value));
        })(task);
    };
};
export {
    pure,
    fromIO,
    run,
    map,
    chain,
    tap,
    sequence,
    sequenceOk
};
//# sourceMappingURL=index.js.map
